module.exports = __webpack_public_path__ + "img/icon-check-blue.2309cc0b.svg";